<script setup lang="ts">
  import { useCssVar } from '@vueuse/core'
  
  import { KsSkeleton, KsSkeletonWrapper } from '@aschehoug/kloss'

  const skeletonLoadingColor = useCssVar('--color-yellow-30')
</script>

<template>
  <div class="top-section-loader">
    <KsSkeletonWrapper class="sk-wrap">
      <KsSkeleton
        width="100%"
        height="100%"
        class="text"
        :background="skeletonLoadingColor"
      />
    </KsSkeletonWrapper>

    <KsSkeletonWrapper class="sk-wrap">
      <KsSkeleton
        width="30%"
        height="2rem"
        class="text"
        :background="skeletonLoadingColor"
      />
    </KsSkeletonWrapper>
  </div>

  <div class="bottom">
    <KsSkeletonWrapper class="sk-wrap">
      <KsSkeleton
        width="30%"
        height="2rem"
        :background="skeletonLoadingColor"
      />
    </KsSkeletonWrapper>

    <KsSkeletonWrapper class="sk-wrap">
      <KsSkeleton
        width="35%"
        height="2rem"
        :background="skeletonLoadingColor"
      />
    </KsSkeletonWrapper>

    <KsSkeletonWrapper class="sk-wrap">
      <KsSkeleton
        width="20%"
        height="2rem"
        :background="skeletonLoadingColor"
      />
    </KsSkeletonWrapper>
  </div>
</template>

<style scoped lang="scss">
  .top-section-loader {
    display: flex;
    gap: 10px;
    align-items: center;

    @include vgs-media-mobile {
      display: block;
    }

    .sk-wrap {
      width: 50%;
      background: var(--color-yellow-20);
      height: 300px;
      border-radius: 10px;
      padding: 1.5em;
      display: flex;

      @include vgs-media-mobile {
        flex-direction: column;
        width: 100%;
        margin-top: 5px;
      }
    }

    .text {
      right: 0;
      display: block;
    }
  }

  .bottom {
    display: block;
    margin-top: 100px;

    .sk-wrap {
      width: 100%;
      margin-top: 5px;
      background: var(--color-yellow-20);
      height: 100px;
      border-radius: 10px;
      padding: 0 1.5em;
      align-items: center;
      display: flex;
    }
  }

</style>
